/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from '@/application';
import { SignInPageService } from '../../../services';
import toast from 'react-hot-toast';

const MODULE_NAME = 'profile.machines.states.signInUser';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.SignInPageService') as SignInPageService;
};

export const getSignInType = async (context: any, event: any) => {
  const currentState = 'GET_SIGN_IN_TYPE';
  const method = 'getSignInType';

  return new Promise(async (resolve, reject) => {
    try {
      const srv = getSrv();
      const content = await srv.getSignInType(event?.payload);
      if (content && content?.signInType) {
        return resolve({
          key: 'GET_SIGN_IN_TYPE_SUCCESS',
          value: {
            ...(content || {}),
            email: event?.payload?.email,
          },
        });
      } else {
        const msg = content?.error;
        toast.error(msg);
        return reject({
          key: 'GET_SIGN_IN_TYPE_FAILURE',
          value: content,
        });
      }
    } catch (err: any) {
      toast.error(err?.message);
      return reject({
        key: 'GET_SIGN_IN_TYPE_FAILURE',
        value: 'Something went wrong please try again!',
      });
    }
  });
};
